import React from "react";
import {SearchModeProp} from "./SearchResultsPage";
import t from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale} from "../../components/Utils";

function SearchResultsTitle(componentProps: SearchModeProp) : JSX.Element {

  const locale = GetCurrentLocale();
  return(
    <section className="bg-primary padding-y heading-page bg-header">
      <div className="container d-flex justify-content-between align-items-center">
        {
          componentProps.keywords !== null ?
            <header className="section-heading">
              <h3 className="section-title h1">{t('search_for')} "{componentProps.keywords}" </h3>
            </header>
            :
            ""
        }
        <ol className="breadcrumb ondark mb-0">
          <li className="breadcrumb-item"><a href={"/" + locale }>{t('home')}</a></li>
          <li className="breadcrumb-item active" aria-current="page">{ t('search') }</li>
        </ol>
      </div>
    </section>
  )
}
export default SearchResultsTitle;
